// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3XAQl","info":"Note_info__10BCr","note":"Note_note__Hqdf9","actions":"Note_actions__2wpxj"};